export default __webpack_public_path__ + "static/media/Naa Dede CV.427a5014.pdf";